import React, { useMemo } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

interface RichTextEditorProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  height?: string
  className?: string
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = "Enter content...",
  height = "200px",
  className = ""
}) => {
  const modules = useMemo(() => ({
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ],
  }), [])

  const formats = [
    'header', 'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'indent', 'align', 'link'
  ]

  return (
    <div className={`rich-text-editor ${className}`}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{ height: height }}
      />
      <style dangerouslySetInnerHTML={{
        __html: `
          .rich-text-editor .ql-editor {
            min-height: ${height};
            font-size: 14px;
            line-height: 1.5;
          }
          .rich-text-editor .ql-toolbar {
            border-top: 1px solid #e5e7eb;
            border-left: 1px solid #e5e7eb;
            border-right: 1px solid #e5e7eb;
            border-radius: 0.5rem 0.5rem 0 0;
          }
          .rich-text-editor .ql-container {
            border-bottom: 1px solid #e5e7eb;
            border-left: 1px solid #e5e7eb;
            border-right: 1px solid #e5e7eb;
            border-radius: 0 0 0.5rem 0.5rem;
          }
          .rich-text-editor .ql-editor.ql-blank::before {
            color: #9ca3af;
            font-style: normal;
          }
          .dark .rich-text-editor .ql-toolbar {
            background-color: #374151;
            border-color: #4b5563;
          }
          .dark .rich-text-editor .ql-container {
            background-color: #1f2937;
            border-color: #4b5563;
          }
          .dark .rich-text-editor .ql-editor {
            color: #f9fafb;
          }
          .dark .rich-text-editor .ql-editor.ql-blank::before {
            color: #6b7280;
          }
          .dark .rich-text-editor .ql-stroke {
            stroke: #9ca3af;
          }
          .dark .rich-text-editor .ql-fill {
            fill: #9ca3af;
          }
          .dark .rich-text-editor .ql-picker-label {
            color: #f9fafb;
          }
          .dark .rich-text-editor .ql-picker-options {
            background-color: #374151;
            border-color: #4b5563;
          }
          .dark .rich-text-editor .ql-picker-item {
            color: #f9fafb;
          }
          .dark .rich-text-editor .ql-picker-item:hover {
            background-color: #4b5563;
          }
        `
      }} />
    </div>
  )
}

export default RichTextEditor
